import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Column, Row, Button, cls, HeaderCompound, Heading } from 'packages/components';
import { CHANGE_PAYMENT_METHOD } from '../../utils/constants';
import { connect } from 'react-redux';
import Assets from '../../../requests/apa/Asset';
import { autobind } from 'packages/core/lib';
import Device from '../../../devices/device';
import Translator from '../../../requests/apa/Translator';
import Asset from "../../../requests/apa/Asset";
import { getWorkflow } from '../../utils/Utils';
import { showModal } from '../../../actions/modal';
import './_styles.scss';

interface IChangeCardProps {
    pbi: any;
    worflowstart: any;
    selectedPaymentMethod: string;
    type: number;
    history: any;
}
class ChangeCard extends Component<RouteComponentProps & IChangeCardProps> {
    public title: string = Translator.get('ticket_subscription_claropagosgate_label', 'Tarjeta de crédito');
    public subTitle: string = Translator.get('updatePaymentMethod_claropagosgate_register_label', 'Tarjeta registrada');
    public textBack: string = Translator.get('top_head_option_button_back', 'REGRESAR');
    public logoUrl: string = Assets.get('logo_clarotv', '');
    public logoMetadata: string = Translator.get('landing_head_logoClarovideo', this.logoUrl);
    public iconReturn: string = Asset.get('top_head_option_back');
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;

    constructor(props: RouteComponentProps & IChangeCardProps) {
        super(props);
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
    }

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    private getCardData(): JSX.Element {
        const { selectedPaymentMethod, worflowstart } = this.props;
        const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
        return (
            <Column lg={12} className={`${CHANGE_PAYMENT_METHOD}-img-content`}>
                <div className={`${CHANGE_PAYMENT_METHOD}-container`}>
                    <img src={Assets.get(`updatePaymentMethod_cardType_icon_${wfs?.paymentMethodData.cardsData[0].card_type}`)} alt="image_card" />
                    <span>{wfs?.paymentMethodData.cardsData[0].pan}</span>
                </div>
            </Column>
        );
    }

    private handleReplace(): void {
        const { pbi, worflowstart, selectedPaymentMethod, type } = this.props;
        const { history } = this.props;
        history.push(`/payment-${selectedPaymentMethod}`, { pbi, worflowstart, selectedPaymentMethod, type, replace: true });
    }

    private handleSelect(): void {
        const { pbi, selectedPaymentMethod } = this.props;
        const { history } = this.props;
        history.push(`/detailtransaction`, { ...pbi, newMethod: selectedPaymentMethod });
    }

    public render(): JSX.Element {
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                {
                    <HeaderCompound
                        disabled
                        align='right'
                        onClick={this.handleBack}
                        image={this.logoMetadata}
                        textBack={this.textBack}
                        icon={this.iconReturn}
                    />
                }
                <Row className={`${CHANGE_PAYMENT_METHOD}-title-center`}>
                    <Column lg={12}>
                        <Heading size={1}>
                            {this.title}
                        </Heading>
                    </Column>
                    <Column lg={12}>
                        <Heading size={3}>
                            {this.subTitle}
                        </Heading>
                    </Column>
                </Row>
                <Row className={`${CHANGE_PAYMENT_METHOD}-content-center`}>
                    {this.getCardData()}
                    <Column lg={12} className={`${CHANGE_PAYMENT_METHOD}-button-content`}>
                        <Button
                            activate
                            type="button"
                            variant="primary"
                            className={cls('focusable', `${CHANGE_PAYMENT_METHOD}-button-select`
                            )}
                            onClick={() => { this.handleSelect() }}
                        >
                            {Translator.get('updatePaymentMethod_access_opton_button_select', 'SELECCIONAR')}
                        </Button>
                    </Column>
                    <Column lg={12}>
                        <Button
                            activate
                            type="button"
                            variant="default"
                            className={cls('focusable', `${CHANGE_PAYMENT_METHOD}-button-replace`
                            )}
                            onClick={() => { this.handleReplace() }}
                        >
                            {Translator.get('updatePaymentMethod_access_opton_button_replace', 'REEMPLAZAR')}
                        </Button>
                    </Column>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal
};

export default connect(null, mapDispatchToProps)(ChangeCard);


// WEBPACK FOOTER //
// ./src/payments/ClaroPagosGate/ChangeCard/index.tsx